import { useTranslation } from "react-i18next";
import NoteModel from "../../../api/models/NoteModel";
import { ChevronLeftIcon } from "@heroicons/react/solid";
import NotesTab from "./NotesTab";
import TabsComponent from "../../tabs/TabsComponent";
import SkillsTab from "./SkillsTab";

type NoteInfoTableProps = {
  isEditable: boolean;
  notes: NoteModel[];
  sessionId?: string | number;
  listAndSetStudentNotes?: Function;
  onClose?: () => void;
  showSkills?: boolean;
  finishedSkills?: string[];
  handleUpdateSkills?: (finishedSkills: string[]) => Promise<boolean>;
};

export default function SessionNotes(props: NoteInfoTableProps) {
  const {
    isEditable,
    notes,
    sessionId,
    listAndSetStudentNotes,
    onClose,
    showSkills,
    finishedSkills,
    handleUpdateSkills,
  } = props;

  const LocalBasePath = "page.sessionInfo";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });

  const tabs = [
    {
      name: t("notes"),
      content: (
        <NotesTab
          notes={notes}
          sessionId={sessionId}
          isEditable={isEditable}
          listAndSetStudentNotes={listAndSetStudentNotes}
        />
      ),
    },
  ];

  if (showSkills) {
    tabs.push({
      name: t("skills"),
      content: (
        <SkillsTab
          finishedSkills={finishedSkills || []}
          handleUpdateSkills={handleUpdateSkills!}
          isEditable={isEditable}
        />
      ),
    });
  }
  

  return (
    <div className="flex h-full flex-col bg-white">
      <div className="p-4">
        <div className="w-full  flex items-center justify-between">
          <div className="text-sm font-medium text-gray-700">
            {t("telawah")}
          </div>
          <div className="ms-3 flex  items-center">
            <button type="button" onClick={onClose}>
              <ChevronLeftIcon className="h-5 w-5 -rotate-90 sm:rtl:rotate-0 sm:ltr:rotate-180" />
            </button>
          </div>
        </div>
      </div>
      <TabsComponent
        tabs={tabs}
        showDropDownOnMobile={false}
        className="px-4"
      />
    </div>
  );
}
